import { Button, TablePagination, styled } from '@mui/material';

export function StyledTablePagination({
  rowsPerPageOptions,
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
}: {
  rowsPerPageOptions?: number[];
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (obj: any) => void;
}) {
  return (
    <TP
      data-testid="table-paginator-testid"
      rowsPerPageOptions={rowsPerPageOptions}
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      slots={{
        actions: {
          previousButton: () => (
            <Button
              onClick={() => onPageChange(null, page - 1)}
              disabled={page <= 0}
              variant="outlined">
              previous page
            </Button>
          ),
          nextButton: () => (
            <Button
              onClick={() => onPageChange(null, page + 1)}
              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              variant="outlined"
              style={{ marginLeft: '8px' }}>
              next page
            </Button>
          ),
        },
      }}
    />
  );
}

const TP = styled(TablePagination)(({ theme }) => ({ borderBottom: 'none' }));
